import { render } from "./UserPayloadMessage.vue?vue&type=template&id=44e37dc4&scoped=true&ts=true"
import script from "./UserPayloadMessage.vue?vue&type=script&lang=ts"
export * from "./UserPayloadMessage.vue?vue&type=script&lang=ts"

import "./UserPayloadMessage.vue?vue&type=style&index=0&id=44e37dc4&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e37dc4"]])

export default __exports__